import { useRef, useState, useEffect } from "react";
import { Modal, Button, Row, Col, Container } from "react-bootstrap";
import style from "./Modal.module.scss";
import arrow from "../../assets/icons/arrow-white.svg";
import { TODIS_FORM_DSC, TODIS_FORM_FIELD_OPTIONS_DESC, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE } from "../Forms";
import { Formik, Form } from "formik";
import { REJECT, TODIS_REJECT } from "../../.config/reject";
import { BsArrowRight, BsExclamationCircleFill } from "react-icons/bs";
import Iframe from "react-iframe";
import html2canvas from "html2canvas";
import {UrlServicesEUACQUIS,Filter,URLPortal, FilterServicesAdd} from "../../.config";
import jsPdf from "jspdf";
import { loadModules } from "esri-loader";
import downloadjs from 'downloadjs';

const TODIS_Visor_EUACQUIS = (props) => {

    var view = null;
    var webmap = null;
    const [webMap, setWebMap] = useState(null);
    const [viewMap, setViewMap] = useState(null);
    const mapEl = useRef(null);
    const print = async () => {
        //var iframes = document.querySelector("iframe"); //te da los Iframes de la pagina
        var iframes = document.getElementById("dashboard");
        var iframeDocument = iframes.contentWindow.document;
        var contenido = iframeDocument.body;
        contenido.querySelectorAll(".header-panel").forEach(e => e.remove());
        
        const canvas = await html2canvas(contenido);
        const dataURL = canvas.toDataURL('image/png');
        downloadjs(dataURL, 'download.png', 'image/png');
    };

    useEffect(() => {
        loadModules(["esri/identity/IdentityManager","esri/views/MapView", "esri/WebMap","esri/Map", "esri/config", "esri/widgets/Expand", "esri/layers/GraphicsLayer", "esri/widgets/Legend","esri/widgets/BasemapGallery", "esri/widgets/LayerList",
        "esri/widgets/Sketch", "esri/widgets/Print", "esri/widgets/CoordinateConversion", "esri/widgets/Bookmarks", "esri/widgets/ScaleBar", "esri/rest/identify", "esri/rest/support/IdentifyParameters", 
        "esri/widgets/DistanceMeasurement2D", "esri/widgets/AreaMeasurement2D", "esri/widgets/Home", 'esri/widgets/Sketch/SketchViewModel', 'esri/Graphic', 
        "esri/layers/FeatureLayer", "esri/widgets/FeatureTable", "esri/widgets/TimeSlider","esri/rest/support/Query","esri/renderers/HeatmapRenderer", "esri/rest/query","esri/layers/MapImageLayer",], {
          css: true
        }).then(([IdentityManager,MapView, WebMap,Map, esriConfig, Expand, GraphicsLayer, Legend, BasemapGallery, LayerList,
          Sketch, Print, CoordinateConversion, Bookmarks, ScaleBar, identify, IdentifyParameters, 
          DistanceMeasurement2D, AreaMeasurement2D, Home, SketchViewModel, Graphic,
          FeatureLayer, FeatureTable, TimeSlider,Query,HeatmapRenderer,query,MapImageLayer]) => {
          // then we load a web map from an id
  
          var bikeTrailsRenderer = {
            type: "simple",
            symbol: {
                type: "simple-line",
                style: "solid",
                color: [0, 255, 255, 0.8],
                width: "10px",
                outline: {
                    width: 10,
                    color: "#FFFF00"
                }
            }
          };
          esriConfig.portalUrl = URLPortal["UrlPortal"];;
          const graphicsLayer = new GraphicsLayer({title:'Layer Draw'});
          const graphicsLayer2 = new GraphicsLayer({title:'Layer Selection Spatial'});
          var activeWidget = null;
          if(props.dataDashboard && props.visor!="EUACQUIS")
          {
            IdentityManager.registerToken({
              server: URLPortal["UrlServicioToken"],
              token: props.dataDashboard.token
            });            
          }
          webmap = new Map({
            basemap: "topo-vector"
          });
        
         /* webmap = new WebMap({
            portalItem: {            
              id : '20f157bf699a42e5b13f315dafb7dcba'//'0cf63cbbac03415197845ea173087851'//'66611fe0654d490996e4f463a9826e89'//'a589237dd7db4a279c5ca24ce1ae6329'// get item id from the props
            }
          });*/
          const mapImageLayer = new MapImageLayer({
            url: UrlServicesEUACQUIS["ServiceBorderMapaBase"]
          });
          
          webmap.add(mapImageLayer);

          setWebMap(webmap);
          window.webmap = webmap;
          view = new MapView({
            map: webmap,
            container: mapEl.current
          });
          window.view = view;
         /* setViewMap(view);
          let sketchSelectionSpatial = new SketchViewModel({
            view: view,
            layer: new GraphicsLayer({title:'Layer Selection Spatial'}),
          })
          */
          /*function callback(){
            //console.log('graphicsLayer2.removeAll()');
            graphicsLayer2.removeAll();
          }
          webmap.add(graphicsLayer);
          webmap.add(graphicsLayer2);
          */
          function createFillSymbol(value, color) {
            return {
              "value": value,
              "symbol": {
                "color": color,
                "type": "simple-fill",
                "style": "solid",
                "outline": {
                  "style": "none"
                }
              },
              "label": value
            };
          }
          
          const Border = new FeatureLayer({
            url: UrlServicesEUACQUIS["ServicesBorderMapServer"],
            insertIndex: 3,
          });
          
          if(props.visor=="EUACQUIS")
          {
            let queryUrl = UrlServicesEUACQUIS["ServicesMapServer"];
            // create the Query object
            let queryObject = new Query();
            queryObject.where = "legislation = '"+props.dataDashboard+"'";
            queryObject.outSpatialReference = { wkid:4269 };
            queryObject.returnGeometry = true;
            queryObject.outFields = [ "transposition_status","regional_partner_id","transposition_status_id"];
          
            // call the executeQueryJSON() method
            query.executeQueryJSON(queryUrl, queryObject).then(function(results){
              

              var feature = results.features;
              var arrayrp = [];
              var color="";
              for (var i = 0; i<feature.length; i++) 
              {
                  if(feature[i].attributes.transposition_status_id=="248")
                  {
                    color="#ffff00"
                  }
                  if(feature[i].attributes.transposition_status_id=="249")
                  {
                    color="#ff0000"
                  }
                  if(feature[i].attributes.transposition_status_id=="260")
                  {
                    color="#4ce600"
                  }
                  if(feature[i].attributes.transposition_status_id=="264")
                  {
                    color="#c2c2c2"
                  }
                arrayrp.push(createFillSymbol(feature[i].attributes.regional_partner_id, color));
              }
              
              const openSpacesRenderer = {
              type: "unique-value",
              field: "country_code",
              uniqueValueInfos: arrayrp 
                  };
          
                  const Boundaries = new FeatureLayer({
                    url: UrlServicesEUACQUIS["ServicesBorderMapServer"],
                    renderer: openSpacesRenderer,
                    opacity: 0.5,
                    insertIndex: 1,
                  });
                
                  webmap.add(Boundaries); 
        
                  const querydata = new Query();
                  querydata.where = "1=1";
        
                  Boundaries.queryExtent(querydata).then(function(results){
                    view.goTo(results.extent);  // go to the extent of the results satisfying the query
                  });
            });
          }
          else
          {
            const querydata = new Query();
            for(var i=0;i<props.dataDashboard.data.length;i++)
            {
              querydata.where = "1=1";        
              Border.queryExtent(querydata).then(function(results){
                    view.goTo(results.extent);  // go to the extent of the results satisfying the query
              });
              var FilterRaiz = "";
              if(Filter[props.dataDashboard.data[i].layerId])
              {
                FilterRaiz = Filter[props.dataDashboard.data[i].layerId];
              }
              const Filtro = `(${props.dataDashboard.data[i].ids.join(', ')})`;
              console.log(Filtro);//este filtro va en definitionExpression
              const CapaMostrar = new FeatureLayer({
                url: props.dataDashboard.data[i].service,
                definitionExpression: FilterRaiz+props.dataDashboard.data[i].layerId+" in "+(Filtro)+""
              });
              webmap.add(CapaMostrar);
              if(FilterServicesAdd[props.dataDashboard.data[i].layerId])
              {
                FilterRaiz = FilterServicesAdd[props.dataDashboard.data[i].layerId];
                 const CapaMostrar = new FeatureLayer({
                  url: FilterRaiz,
                  definitionExpression: "1=1",
                  });
                  CapaMostrar.opacity  = 0.4;
                  webmap.add(CapaMostrar);
              }
            }
             
          }

          var homeWidget = new Home({
            view: view
          });
  
          view.ui.add(homeWidget, "top-left");
  
          const baseMap = new Expand({
            view,
            content: new BasemapGallery({ view }),
            expandIconClass: "esri-icon-basemap",
            expandTooltip: "Open base maps gallery",
            group: "apps-top"
          });
          view.ui.add(baseMap, "bottom-trailing");
  
          const legend = new Expand({
            content: new Legend({ view }),
            view,
            expandIconClass: "esri-icon-legend",
            expandTooltip: "Legend",
            group: "apps-top"
          });
          view.ui.add(legend, "bottom-trailing");
  
          const layerList = new Expand({
            content: new LayerList({ view }),
            view,
            expandIconClass: "esri-icon-layers",
            expandTooltip: "Display the list of layers",
            group: "apps-top"
          });
          view.ui.add(layerList, "bottom-trailing");
  
          const bookMark = new Expand({
            content: new Bookmarks({
              view: view,
              editingEnabled: true,
              visibleElements: {
                time: false // don't show the time (h:m:s) next to the date
              }
            }),
            view,
            expandIconClass: "esri-icon-bookmark",
            expandTooltip: "Add a bookmark",
            group: "apps-top"
          });
          view.ui.add(bookMark, "bottom-trailing");
  
          const sketch = new Expand({
            content: new Sketch({ layer: graphicsLayer, view, creationMode: "update" }),
            view,
            expandIconClass: "esri-icon-edit",
            expandTooltip: "Create and annotate shapes or markers on the map",
            group: "apps-top"
          });
          view.ui.add(sketch, "bottom-trailing");

          const print = new Expand({
            content: new Print({ view, printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task" }),
            view,
            expandIconClass: "esri-icon-printer",
            expandTooltip: "Print the current map view",
            group: "apps-top"
          });
          
          view.ui.add(print, "bottom-trailing");
          /*const print = new Expand({
            content: new Print({ view, printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task" }),
            view,
            expandIconClass: "esri-icon-printer",
            expandTooltip: "Print",
            group: "apps-top"
          });
          view.ui.add(print, "bottom-trailing");*/
  
         /* const conversionWidget = new Expand({
            content: new CoordinateConversion({ view }),
            view,
            expandIconClass: "esri-icon-map-pin",
            expandTooltip: "Coordinate Conversion",
            group: "apps-top"
          });
          view.ui.add(conversionWidget, "bottom-trailing");*/
  
          const scaleBar = new ScaleBar({
            view: view,
            unit: "dual", // The scale bar displays both metric and non-metric units.
            expandTooltip:"Restore map view"
          });
  
          // Add the widget to the bottom left corner of the view
          view.ui.add(scaleBar, { position: "bottom-left"});
  
       /*   //WIDGET MEASURE
          let node = domConstruct.create("div", {
            class:'esri-ui-top-right esri-ui-corner',
          });
  
          let div = domConstruct.create("div", {
            id:"topbar",
            class:'esri-component'
          }, node);
  
          domConstruct.create("button", {
            class:'esri-button action-button esri-icon-measure-line',
            title:"Measure distance between two or more points",
            id:"distanceButton",
            onclick: function() { distanceButton(this) }
          }, div);
  
          domConstruct.create("button", {
            class:'esri-button action-button esri-icon-measure-area',
            title:"Measure area",
            id:"areaButton",
            onclick: function() { areaButton(this) }
          }, div);
  
          function distanceButton(e) {
            setActiveWidget(null);
            if (!e.classList.contains("active")) {
              setActiveWidget("distance");
            } else {
              setActiveButton(null);
            }
          }
  
          function areaButton(e) {
            setActiveWidget(null);
            if (!e.classList.contains("active")) {
              setActiveWidget("area");
            } else {
              setActiveButton(null);
            }
          }
  
          function setActiveWidget(type) {
            switch (type) {
              case "distance":
                activeWidget = new DistanceMeasurement2D({
                  view: view
                });
                // skip the initial 'new measurement' button
                activeWidget.viewModel.start();
                view.ui.add(activeWidget, "top-right");
                setActiveButton(document.getElementById("distanceButton"));
                break;
              case "area":
                activeWidget = new AreaMeasurement2D({
                  view: view
                });
                // skip the initial 'new measurement' button
                activeWidget.viewModel.start();
                view.ui.add(activeWidget, "top-right");
                setActiveButton(document.getElementById("areaButton"));
                break;
              case null:
                if (activeWidget) {
                  view.ui.remove(activeWidget);
                  activeWidget.destroy();
                  activeWidget = null;
                }
                break;
            }
          }
  
          function setActiveButton(selectedButton) {
            // focus the view to activate keyboard shortcuts for sketching
            view.focus();
            var elements = document.getElementsByClassName("active");
            for (var i = 0; i < elements.length; i++) {
              elements[i].classList.remove("active");
            }
            if (selectedButton) {
              selectedButton.classList.add("active");
            }
          }*/
  
          /*const measureWidget = new Expand({
            content: node,
            view,
            expandIconClass: "esri-icon-measure",
            expandTooltip: "Measure",
            group: "apps-top"
          });
          view.ui.add(measureWidget, "bottom-trailing");*/
  
          //WIDGET TIMESLIDER
          /*const timeSlider = new TimeSlider({
            view: view,
            timeVisible: true, // show the time stamps on the timeslider
            stops : {
              interval: {
                value: 3,
                unit: "years"
              }
            },
            loop: true
          });
          */
          //view.ui.add(timeSlider, "bottom-leading");
  
        
  
          view.when(function() {
            let popup = view.popup;
            popup.viewModel.on("trigger-action", event => {
                //console.log(popup.viewModel.selectedFeature);
                if (event.action.id === "openFileProject") {
                  var attributes = popup.viewModel.selectedFeature.attributes;
                  var id = attributes["npm_road_id"];
                  attributes.countryCode = attributes.country_code;
                  props.requestData(attributes);
                  var element = document.getElementById("tblResult");
                  document.getElementById("tblResult").innerHTML = "";
                  document.getElementById("tblResult").style.display = "none";
                  element.classList.remove("table-size");
                  props.expandingResultTable(false);
                  props.expanding();
                }
            });
          });
  
        });
        return () => {
          if (!!view) {
            view.destroy();
            view = null;
          }
        };
  
      }, [props.requesid])
return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={style.sizeModaldashboard}
            dialogClassName={style.sizeModal90}
        >
            <Modal.Header closeButton className={style.modalHeader}>
                {/* <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    {props.title}
                    
                    <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{margin: "0.5rem"}} onClick={print}>Download <BsArrowRight className="ms-2" size={20} /></Button>
                </Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
            <Container fluid className={style.todisSharingMapWrapper}>
            <div style={{ height: "calc(90vh - 100px)", width:"100%" }}  ref={mapEl} />
            </Container>
            </Modal.Body>
            {/* <Modal.Footer>
                
            </Modal.Footer>  */}
        </Modal>
    )
}

export { TODIS_Visor_EUACQUIS };